import { useContext } from 'react'

import Input from '../../../components/input/Input'
import { HeaderLarge } from '../../../components/typography/Header'
import { TranslatedWordsContext } from '../../../contexts/TranslatedWordsContext'

function CheckoutMenuHeader({ title, searchFilter, setSearchFilter }) {
  const { translatedWords } = useContext(TranslatedWordsContext)

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '6px',
      }}
    >
      <div>
        <HeaderLarge>{title}</HeaderLarge>
      </div>

      <div>
        <Input
          value={searchFilter}
          setValue={setSearchFilter}
          placeholder={
            title === translatedWords?.all
              ? `${translatedWords?.search}...`
              : `${translatedWords?.search} ${title}...`
          }
        />
      </div>
    </div>
  )
}

export default CheckoutMenuHeader
